/**
 * Admin orders list [351:2](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=351-2)
 * Mobile orders list [297:21810](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=297-21810)
 */
export const ADMIN_ORDERS_PATH = '/admin/orders'

export const ADMIN_ORDERS = {
  title: 'Orders',
  subtitle: 'Manage and track 1,245 active deliveries.',
  searchPlaceholder: 'Search orders, customers, riders...',
  mobileSearchPlaceholder: 'Search orders, IDs...',
  filtersLabel: 'Filters',
  exportLabel: 'Export CSV',
  newOrderLabel: 'New Order',
  trackRiderLabel: 'Track Rider',
  tabs: [
    { id: 'all', label: 'All Orders', mobileLabel: 'All' },
    { id: 'live', label: 'Live', dot: true },
    { id: 'preparing', label: 'Preparing' },
    { id: 'dispatched', label: 'Dispatched' },
    { id: 'delivered', label: 'Delivered' },
    { id: 'cancelled', label: 'Cancelled' },
    { id: 'failed', label: 'Failed' },
    { id: 'refunded', label: 'Refunded' },
  ],
  columns: {
    orderId: 'Order ID',
    customer: 'Customer',
    merchant: 'Merchant',
    items: 'Items',
    total: 'Total (₦)',
    status: 'Status',
    elapsed: 'Elapsed',
    actions: 'Actions',
  },
  pagination: {
    showingPrefix: 'Showing',
    range: '1–10',
    total: 1245,
    totalLabel: 'orders',
    page: 1,
    totalPages: 125,
  },
  orders: [
    {
      id: 'KB-8924',
      customer: { name: 'Oluwaseun Abimbola', phone: '+234 801 234 5678', shortName: 'Oluwaseun A.' },
      merchant: { name: 'Mama Cass', location: 'Ikoyi', label: 'Mama Cass - Ikoyi' },
      items: 3,
      total: '12,450',
      status: 'preparing',
      statusLabel: 'Preparing',
      elapsed: '14m',
      elapsedSuffix: 'elapsed',
      elapsedWarning: false,
      mobileAction: 'contact',
    },
    {
      id: 'KB-8923',
      customer: { name: 'Chidi Okafor', phone: '+234 902 111 2233', shortName: 'Chidi O.' },
      merchant: { name: 'Chicken Republic', location: 'Surulere', label: 'Chicken Republic' },
      items: 1,
      total: '4,200',
      status: 'dispatched',
      statusLabel: 'Dispatched',
      elapsed: '32m',
      elapsedSuffix: 'elapsed',
      elapsedWarning: false,
      mobileAction: 'trackRider',
    },
    {
      id: 'KB-8919',
      customer: { name: 'Zainab Bello', phone: '+234 705 888 9900', shortName: 'Zainab B.' },
      merchant: { name: 'Mega Chicken', location: 'Ikeja GRA', label: 'Mega Chicken' },
      items: 5,
      total: '18,900',
      status: 'delivered',
      statusLabel: 'Delivered',
      elapsed: '45m',
      elapsedSuffix: 'total',
      elapsedWarning: false,
      mobileAction: 'none',
    },
    {
      id: 'ORD-8918',
      customer: { name: 'Emeka Nwosu', phone: '+234 803 456 7890' },
      merchant: { name: 'Chicken Republic', location: 'Yaba' },
      items: 2,
      total: '6,800',
      status: 'live',
      statusLabel: 'Live',
      elapsed: '3m',
      elapsedWarning: false,
    },
    {
      id: 'ORD-8917',
      customer: { name: 'Fatima Ali', phone: '+234 806 222 3344' },
      merchant: { name: 'Shoprite', location: 'Victoria Island' },
      items: 8,
      total: '45,200',
      status: 'preparing',
      statusLabel: 'Preparing',
      elapsed: '8m',
      elapsedWarning: false,
    },
    {
      id: 'ORD-8916',
      customer: { name: 'David Okon', phone: '+234 809 333 4455' },
      merchant: { name: 'Dominos Pizza', location: 'Ajah' },
      items: 2,
      total: '9,100',
      status: 'cancelled',
      statusLabel: 'Cancelled',
      elapsed: '1h 2m',
      elapsedWarning: false,
    },
    {
      id: 'ORD-8915',
      customer: { name: 'Grace Adeyemi', phone: '+234 701 444 5566' },
      merchant: { name: 'Burger King', location: 'Ikeja' },
      items: 4,
      total: '15,300',
      status: 'delivered',
      statusLabel: 'Delivered',
      elapsed: '28m',
      elapsedWarning: false,
    },
    {
      id: 'ORD-8914',
      customer: { name: 'Ibrahim Musa', phone: '+234 808 555 6677' },
      merchant: { name: 'Tantalizers', location: 'Gbagada' },
      items: 1,
      total: '3,500',
      status: 'failed',
      statusLabel: 'Failed',
      elapsed: '52m',
      elapsedWarning: true,
    },
    {
      id: 'ORD-8913',
      customer: { name: 'Ngozi Eze', phone: '+234 802 666 7788' },
      merchant: { name: 'Sweet Sensation', location: 'Maryland' },
      items: 6,
      total: '18,750',
      status: 'refunded',
      statusLabel: 'Refunded',
      elapsed: '2h 10m',
      elapsedWarning: false,
    },
    {
      id: 'ORD-8912',
      customer: { name: 'Tunde Bakare', phone: '+234 907 777 8899' },
      merchant: { name: 'Cold Stone', location: 'Lekki' },
      items: 2,
      total: '7,400',
      status: 'dispatched',
      statusLabel: 'Dispatched',
      elapsed: '22m',
      elapsedWarning: false,
    },
  ],
}
